import React, { useContext, useEffect, useState } from 'react';
import { ConfigProvider, Dropdown, Space, theme } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import styles from "./DropDownBalance.module.css";
import stylesSetting from "../../../Pages/Settings/settings.module.css"
import formatCurrency from "../../../Utils/formatCurrency";
import { Context } from "../../../index";
import { useSpring, animated } from '@react-spring/web';

function DropDownBalance({ balance, balance_bonus_casino, balance_bonus_snake, freespins, currency, placement }) {
    const { store } = useContext(Context);
    const [activeBalance,setActiveBalance] = useState(false);

    // Локальное состояние для предыдущего значения баланса
    const [prevBalance, setPrevBalance] = useState(balance);

    // Хук анимации
    const [props, api] = useSpring(() => ({
        number: balance,
        config: { tension: 200, friction: 20 },
    }));

    // Отслеживаем изменения balance с помощью useEffect
    useEffect(() => {
        api.start({ number: balance });
        setPrevBalance(balance); // Обновляем предыдущее значение
    }, [balance, api]);

    const items = [
        {
            label: <div>{store.dataLang["balance_bonus_casino"]}: {formatCurrency(balance_bonus_casino, "cost")} </div>,
            key: '0',
        },
        {
            label: <div>{store.dataLang["balance_bonus_snake"]}: {formatCurrency(balance_bonus_snake, "cost")}</div>,
            key: '1',
        },
        {
            label: <div>{store.dataLang["freespins_name"]}: {freespins} </div>,
            key: '2'
        }
    ];

    return (
        <>
        {activeBalance&&<div className='backgroundMenuClose' onClick={()=>setActiveBalance(false)}></div>}
        <div className={styles.button} onClick={()=>setActiveBalance(true)}>{formatCurrency(balance,"cost")}</div>
        <div className={styles.blockBalanceInfo + " "+(activeBalance?styles.active:"")}>
            <div style={{padding:"10px",paddingBottom:0}}>Ваш баланс</div>
            <div>

            
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    Основной
                </div>
                <div className={styles.main}>{formatCurrency(store.user.balance,"cost")}</div>

            </div>
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    Бонусный
                </div>
                <div className={styles.main}>{formatCurrency(balance_bonus_casino,"cost")}</div>

            </div>
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    Фри спины
                </div>
                <div className={styles.main}>{freespins}</div>

            </div>
            </div>

        </div>
        </>
    );
}

export default DropDownBalance;
